import { client } from "../../../../actions";
import { authHeader } from "../../../../helpers/auth-header";
import actions from "../actions/actions";

const getTags = () => async (dispatch) => {
	const response = await client.get("/Meter/meter_tags", {
		headers: authHeader(),
	});
	dispatch({
		type: actions.METER_TAGS_LOADED,
		payload: response.data,
	});
};

export default getTags;
